import Route from '@ember/routing/route';

export default class CoachingSessionsIndexRoute extends Route {
  queryParams = {
    sessionType: { replace: true, scope: 'controller' },
    statuses: { replace: true, scope: 'controller' },
    offset: { replace: true, scope: 'controller' },
  };
}
